import React from 'react';
import { Components } from '../../common/interfaces';
import { getErrorMessage } from '../../utils/ErrorUtil';
import { Strings } from './strings';
import { OrderSummaryWrapper, Row, DividerRow } from './styled';
var OrderSummary = function OrderSummary(_ref) {
  var content = _ref.content,
    onError = _ref.onError,
    headingLevel = _ref.headingLevel,
    price = _ref.price,
    formattedTotalWithTax = _ref.formattedTotalWithTax;
  if (!content) return null;
  if (!content.heading || !content.subscription || !content.tax || !content.total || !formattedTotalWithTax) {
    onError(getErrorMessage(Components.ORDER_SUMMARY, "".concat(Strings.MISSING_CONTENT_ERROR)));
    return null;
  }
  var orderSummaryHeading = content.heading;
  var orderSummarySubscription = content.subscription;
  var orderSummaryTax = content.tax;
  var orderSummaryTotal = content.total;
  var subscriptionPrice = price.subscriptionPrice,
    tax = price.tax,
    total = price.total,
    hasTrial = price.hasTrial;
  var displayTax = tax && total && !hasTrial;
  return /*#__PURE__*/React.createElement(OrderSummaryWrapper, {
    "data-test": 'ORDER_SUMMARY'
  }, /*#__PURE__*/React.createElement("h2", {
    "aria-level": headingLevel
  }, orderSummaryHeading), /*#__PURE__*/React.createElement(Row, {
    className: 'subTotal'
  }, /*#__PURE__*/React.createElement("div", null, orderSummarySubscription), /*#__PURE__*/React.createElement("div", {
    className: 'subPrice'
  }, subscriptionPrice)), displayTax ? /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("div", null, orderSummaryTax), /*#__PURE__*/React.createElement("div", null, tax)) : /*#__PURE__*/React.createElement(DividerRow, null), /*#__PURE__*/React.createElement(Row, {
    className: 'total'
  }, /*#__PURE__*/React.createElement("div", null, orderSummaryTotal), /*#__PURE__*/React.createElement("div", {
    "data-test": 'ORDER_TOTAL'
  }, displayTax ? total : formattedTotalWithTax)));
};
export default /*#__PURE__*/React.memo(OrderSummary);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/components/OrderSummary/index.js
// module id = 3977
// module chunks = 11